import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GlobalStyles } from './styles/GlobalStyles';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage';
import AgentesPage from './pages/AgentesPage';
import ModelosIAPage from './pages/ModelosIAPage';
import ConsultoriaPage from './pages/ConsultoriaPage';
import ContatoPage from './pages/ContatoPage';

function App() {
  return (
    <Router>
      <GlobalStyles />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/agentes-inteligentes" element={<AgentesPage />} />
          <Route path="/modelos-ia" element={<ModelosIAPage />} />
          <Route path="/consultoria-dados" element={<ConsultoriaPage />} />
          <Route path="/contato" element={<ContatoPage />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
